import { combineReducers } from 'redux';
import user from 'src/redux/user/reducer';

export const reducers = combineReducers({
  user,
});
